// The Story room's logic (W7b), ported from SuiteStory (continuity, astronomy, story-time suggestions, co-presence) and
// SuiteModel (presence inference, scene shape, glossary, name generator, character-study answers, entity colours, travel
// between places, a character's short name), with
// the app's timeline and chronology data and typed writes. See each module's header for its Swift source.
export {
  deviceZone, zoneNamed, zoneName, sameZone, offsetSeconds, components, instant, reinterpret, adding, settingHour, nextWeekday,
  wholeYears, formatDate, weekdayName, iso8601, utcMs, UTC_ZONE,
  type Zone, type Components, type CalendarUnit, type DateStyle, type TimeStyle,
} from './zones.ts';
export { isDaylight, moon, phaseName, sunDay, sunElevation, utcOffset, type MoonState, type SunDay } from './astronomy.ts';
export {
  entityNames, explicitPresence, speakingIDs, fragmentPresence, mentionedIDs, mentions, namePattern, presence, presenceRank, presenceRows, reference,
  ENTITY_KIND_LABELS, PRESENCE_LABELS, PRESENCE_LEVELS,
  type EntityNames, type Mention, type Presence, type PresenceLevel, type PresenceRow,
} from '../presence.ts';
export { scriptSpeeches, type SpeechCount } from './speeches.ts';
export { suggestDoubling, colourGraph, type Doubling, type DoublingActor, type QuickChange } from './doubling.ts';
export { formatInScene, sceneEnd, sceneFacts, sceneMoment, sceneZone, type SceneFacts, type SceneFactsOptions } from './sceneFacts.ts';
export {
  checkContinuity, finding as continuityFinding, journeys, numberFromWords, openingRange, readBeatSheet, structure as beatStructure, wordBefore,
  CONTINUITY_KINDS, TRAVEL_SLACK, CONTINUITY_LABELS, type ContinuityFinding, type ContinuityKind, type ContinuityOptions,
} from './continuity.ts';
export { opening, storyTimeScenes, suggestStoryTimes, timeOfDay, type StoryTimeProposal, type StoryTimeScene } from './storyTime.ts';
export {
  calendarLanes, chronology, CoPresence, manuscriptCoPresence, presentByScene, readingOrderLanes, sceneKinds, sceneTime,
  storyAppearances, storyPeople, storyScenes, timeVersusOrder,
  type CalendarLanes, type CalendarLink, type CalendarMark, type Chronology, type ChronologyBar, type ChronologyGrouping, type LaneGap,
  type LaneMark, type StoryScene, type TimeOrderPoint,
} from './timeline.ts';
export {
  measureShape, printfFixed, sceneShapeOf, shapeCSV, shapeNotables, totalWords as shapeTotalWords, unwritten, vocabulary, VOCABULARY_WINDOW,
  type SceneShape, type ShapeAverages, type ShapeInput, type ShapeMeasure, type ShapeNotable, type ShapeScene,
} from './shape.ts';
export {
  caseInsensitiveOrder, decodeGlossaryEntry, DictionarySync, glossaryEntry, glossaryID, glossaryRows, glossarySuggestions, glossaryWords,
  readGlossary, readPronunciations, spellings, spellingWords, GLOSSARY_ENTITY_KIND, GLOSSARY_KIND_LABELS, GLOSSARY_KINDS,
  type GlossaryEntry, type GlossaryKind, type GlossaryRow, type GlossarySource, type GlossarySuggestion,
} from './glossary.ts';
export {
  alliterates, BUILT_IN_LISTS, BUILT_IN_ORIGINS, commonNames, decodeNameOptions, DEFAULT_LIST_IDS, defaultNameOptions, feminineOf, foldName,
  fullName, generateNames, initialOf, nameListTitle, nextBelow, parseNames, randomElement, SplitMix64, systemRandom, NAME_LIST_KIND_LABELS,
  type FilterMode, type GeneratedName, type NameFilter, type NameGender, type NameList, type NameListKind, type NameOptions, type NameResult,
  type RandomSource,
} from './names.ts';
export { studyAnswers, type StudyAnswer } from './characterStudy.ts';
export {
  beforeCars, decodeTravelSettings, distanceText, durationText, isPeriodTravel, journeyDuration, measurementRegion, placeDistance, readTravel, sameTravel,
  shortestJourney, todayTravel, travelDistance, travelMode, travelPhrase, travelTime, usesMiles, DETOUR, MILES_PER_KM, TRAVEL_KEY, TRAVEL_SUGGESTIONS,
  type TravelMode, type TravelSettings,
} from './travel.ts';
export { castCardLine, shortName, studiedCharacter } from './cast.ts';
export { newEntity, StoryEditor } from './edits.ts';
